import * as Yup from 'yup';
import { PHONE_REGEX } from '../../shared/constants/regex';
import { CONTACT_METHOD_TYPE } from '../constants/addPersonFormConstants';

const addPlaceSchema = Yup.object({
  PlaceName: Yup.string().nullable().required('Place Name is required'),
  ContactMethodType: Yup.string()
    .nullable()
    .when('ContactMethod', {
      is: (value) => Boolean(value),
      then: (schema) => schema.required('Contact Type is required'),
    }),
  Info: Yup.string()
    .nullable()
    .when('ContactMethod', (contactMethod, schema) => {
      if (contactMethod === CONTACT_METHOD_TYPE.PHONE) {
        return schema.matches(PHONE_REGEX, 'Invalid phone number');
      }
      if (contactMethod === CONTACT_METHOD_TYPE.EMAIL) {
        return schema.email('Invalid email address');
      }
      return schema;
    }),
});

export default addPlaceSchema;
